<template>
	<div
		style="width: 100%; min-height: 62px; border-radius: 8px; display: flex; flex-direction: column; padding: 15px;"
		:style="{
			'background-color': uploadFailed ? 'var(--stan-negative-light-color)' : 'var(--stan-gray-soft-color)',
		}"
	>
		<!-- Stanley generated file info -->
		<div v-if="generatedBy" class="generated-file-info">
			<div class="generated-message">
				Stanley generated this file. To make changes, you can download it and edit it in Canva before re-uploading.
			</div>
			<div class="learn-more-link" @click="handleLearnMore">
				Learn More
			</div>
		</div>

		<!-- Main content row -->
		<div class="main-content-row">
			<!-- Status + file name -->
			<div class="file-name-icon-container">
				<InlineSvg v-if="isUploading" src="/images/icons/ic-reload.svg" class="status-icon rotating" />
				<InlineSvg v-else-if="isErrored" src="/images/icons/ic-warning-circle-filled-negative.svg" class="status-icon" />
				<InlineSvg v-else-if="generatedBy" src="/images/icons-2025/ai-inform.svg" class="status-icon generated-icon" />
				<InlineSvg v-else src="/images/icons/ic-check-circle-filled-positive.svg" class="status-icon" />

				<span
					class="para-2 text-bold file-name"
					:class="{
						'text-light': isUploading,
						'stan-text-danger': uploadFailed,
					}"
					>{{ fileName }}</span
				>

				<InlineSvg v-if="isUploading" class="delete-file-icon" src="/images/icons/ic-trash.svg" @click="deleteFile" />
			</div>

			<!-- Action buttons -->
			<div v-if="isUploading" class="para-3 text-light"><span class="text-bold">Uploading...</span> ({{ uploadProgress }}%)</div>
			<div v-else style="display: flex; gap: 10px; align-items: center">
				<span v-if="uploadFailed" class="para-3 stan-text-danger text-bold">
					Failed to upload
				</span>
				<AppButton
					v-else-if="!isUrl"
					name="download-uploaded-product"
					:size="'sm'"
					:outline="true"
					icon="/images/icons/ic-digital-download.svg"
					@click="downloadFile"
				>
					Download
				</AppButton>

				<InlineSvg v-if="!editNotDelete" class="delete-file-icon" src="/images/icons/ic-trash.svg" @click="deleteFile" />
				<InlineSvg v-else class="delete-file-icon" src="/images/icons/ic-edit.svg" @click="editFile" />
			</div>
		</div>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex'

	export default {
		props: {
			fileName: {
				type: String,
				default: '',
			},
			url: {
				type: String,
				default: '',
			},
			isUploading: {
				type: Boolean,
				default: true,
			},
			uploadProgress: {
				type: Number,
				default: 0,
			},
			isErrored: {
				type: Boolean,
				default: false,
			},
			isUrl: {
				type: Boolean,
				default: false,
			},
			editNotDelete: {
				type: Boolean,
				default: false,
			},
			generatedBy: {
				type: String,
				default: '',
			},
		},
		name: 'UploadedItemRow',
		methods: {
			deleteFile() {
				this.$emit('deleteFile')
			},
			downloadFile() {
				const link = document.createElement('a')
				link.href = this.url
				link.download = this.fileName
				document.body.appendChild(link)
				link.click()
				document.body.removeChild(link)

				if (this.generatedBy) {
					this.$stanAnalytics('chat-v2-generated-file-downloaded', {
						meta: { user_id: this.user?.user_id, username: this.user?.username },
						props: { product_generation_ulid: this.generatedBy },
					})
				}
			},
			editFile() {
				this.$emit('edit-file')
			},
			handleLearnMore() {
				window.open('https://www.stanwith.me/blog/how-to-use-stanley-to-create-products', '_blank')
			},
		},
		computed: {
			...mapGetters('Auth', ['user']),
			uploadFailed() {
				return !this.isUploading && this.isErrored
			},
		},
	}
</script>

<style lang="scss" scoped>
	$fadeInDuration: 0.3s;
	.delete-file-icon {
		cursor: pointer;
	}

	.loader-icon {
		height: 25px;
		width: 25px;
	}

	.rotating {
		animation: rotate 2s ease-in-out infinite;
		animation-delay: calc($fadeInDuration / 2);
	}

	@keyframes rotate {
		from {
			transform: rotate(0deg);
		}
		to {
			transform: rotate(360deg);
		}
	}

	.file-name-icon-container {
		display: flex;
		gap: 10px;
		align-items: center;
		max-width: 50%;

		.status-icon {
			min-width: 24px;
		}

		.file-name {
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}
	}

	.main-content-row {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-top: 8px;
	}

	.generated-file-info {
		margin-bottom: 8px;
		max-width: 100%;
	}

	.generated-message {
		color: #6875a1;
		font-family: Inter;
		font-size: 12px;
		font-style: normal;
		font-weight: 500;
		line-height: 16px;
		letter-spacing: -0.24px;
		margin-bottom: 4px;
	}

	.learn-more-link {
		color: #6355ff;
		font-family: Inter;
		font-size: 12px;
		font-style: normal;
		font-weight: 600;
		line-height: 16px;
		letter-spacing: -0.24px;
		cursor: pointer;
	}

	.generated-icon::v-deep {
		path {
			fill: #6355ff;
		}
	}
</style>
